import fetchEmailNotificationSettings, {
    EmailNotificationSettingsFormData,
} from './fetchEmailNotificationSettings';
import fetchGeneralSettings, { GeneralSettings } from './fetchGeneralSettings';
import fetchMailingSettings, { MailingSettingsFormData } from './fetchMailingSettings';

export type FetchSettingsResponse = GeneralSettings | MailingSettingsFormData | EmailNotificationSettingsFormData;

const fetchSettings = async (name: string, selectedAgencyId: string, signal: AbortSignal): Promise<FetchSettingsResponse> => {
    switch (name) {
        case 'SettingsGeneral':
            return await fetchGeneralSettings(selectedAgencyId, signal);
        case 'SettingsEmailTemplates':
            return await fetchMailingSettings(selectedAgencyId, signal);
        case 'SettingsEmailNotifications':
            return await fetchEmailNotificationSettings(selectedAgencyId, signal);
        default:
            break;
    }
}

export default fetchSettings;
